// Single fetch wrapper for the whole app. Auth is a JSESSIONID session
// cookie (same-origin via the CRA proxy), so no auth headers are needed.
export class ApiError extends Error {
  constructor(status, body, text) {
    super((body && (body.error || body.message)) || text || `HTTP ${status}`);
    this.name = 'ApiError';
    this.status = status;
    // Parsed JSON error body, or null if the response wasn't JSON.
    this.body = body;
    // Raw response text, for endpoints that return plain-text errors.
    this.text = text;
  }
}

export async function request(path, { method = 'GET', body } = {}) {
  const response = await fetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    credentials: 'include',
  });

  if (!response.ok) {
    const text = await response.text();
    let json = null;
    try {
      json = JSON.parse(text);
    } catch {
      // not JSON — keep raw text
    }
    throw new ApiError(response.status, json, text);
  }

  const text = await response.text();
  return text ? JSON.parse(text) : null;
}
